import request from '../../../common/RemoteApiService';

const config = window.userManagementConfig;

const baseUrl = window.userManagementConfig.api.baseUrl;
const endpoints = window.userManagementConfig.api.endpoints;

export const getAll = async (merchantUuid, page) => {
  const response = await request('GET', endpoints.users.getAll(baseUrl, merchantUuid, page), null, {
    credentials: 'include',
  });

  return response.json();
};

export async function remove(merchantUuid, user) {
  await request('DELETE', endpoints.users.delete(baseUrl, merchantUuid, user.uuid), null, {
    credentials: 'include',
  });
};

export async function create(merchantUuid, user) {
  await request('POST', endpoints.users.create(baseUrl, merchantUuid), user, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export async function update(merchantUuid, user) {
  await request('PATCH', endpoints.users.update(baseUrl, merchantUuid, user.uuid), user, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export async function createOrUpdate(merchantUuid, user) {
  if (user.uuid) {
    return update(merchantUuid, user);
  }

  return create(merchantUuid, user);
};
